module.exports = __webpack_public_path__ + "static/media/TN-Women-DressShoes-2.0.456c4e98.svg";